import { useEffect } from "react";
import { X } from "lucide-react";
import PopuIABlock from "@/components/PopuIABlock";

export default function PopuIaModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[90] flex items-start md:items-center justify-center p-0 md:p-6"
      style={{ background: "rgba(0,0,0,0.65)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
      data-testid="popu-ia-modal"
    >
      <div
        className="relative w-full max-w-3xl rounded-none md:rounded-xl border shadow-2xl overflow-hidden"
        style={{ background: "var(--bg)", borderColor: "var(--border)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          data-testid="popu-ia-modal-close"
          aria-label="Cerrar POPU IA"
          className="absolute top-3 right-3 z-10 p-2 rounded-full hover:bg-[color:var(--surface-2)] transition"
          style={{ color: "var(--text)" }}
        >
          <X size={22} strokeWidth={2.4} />
        </button>
        <div className="max-h-[92vh] md:max-h-[88vh] overflow-y-auto p-1 md:p-2">
          <PopuIABlock />
        </div>
      </div>
    </div>
  );
}
